import global from "./ja/global";
import sideMenu from "./ja/sideMenu";
import login from "./ja/login";
import movie from "./ja/movie";
import schedule from "./ja/schedule";
import ruleTemplate from "./ja/ruleTemplate";
import discountRuleTemplate from "./ja/discountRuleTemplate";
import version from "./ja/version";
import shop from "./ja/shop";
import couponLib from "./ja/couponLib";
import report from "./ja/report";
import house from "./ja/house";
import setting from "./ja/setting";
import theatre from "./ja/theatre";
import userManagement from "./ja/user";
import role from "./ja/role";
import brand from "./ja/brand";
import accounting from "./ja/accounting";
import otherGoods from "./ja/otherGoods";
import calendar from "./ja/calendar";
import errorMsg from "./ja/errorMsg";
import form from "./ja/form";
import clientManagement from "./ja/client";
import restrict from "./ja/restrict";
import reigon from "./ja/reigon";
import accountPayableManagement from "./ja/accountPayableManagement";
import accountPayable from "./ja/accountPayable";
import accountReceivable from "./ja/accountReceivable.js";
import otherRevenue from "./ja/otherRevenue";
import nonArrivalTicketRecord from "./ja/nonArrivalTicketRecord";
import monthlyClosing from "./ja/monthlyClosing";
import cashierReport from "./ja/cashierReport";
import pdf from "./ja/pdf";
import inventoryAdjustmentLog from "./ja/inventoryAdjustmentLog";
import dailyClosing from "./ja/dailyClosing";
import businessDaily from "./ja/businessDaily";

import bookkeeping from "./ja/bookKeeping";
import operations from "./ja/operations";
import salesGroup from "./ja/salesGroupManagement";
import accountingReportDownload from "./ja/accountingReportDownload";
import pdfAccountsReceivableBalance from "./ja/pdfAccountsReceivableBalance";
import pdfFilmFeeBalance from "./ja/pdfFilmFeeBalance";
import pdfReceivableVerifyPdf from "./ja/pdfReceivableVerifyPdf";
import weather from "./ja/weather";
import businessDailyDetail from "./ja/businessDailyDetail";
import notification from "./ja/notification";
import Signage from "./ja/signage";
import CinemaWebsite from "./ja/cinemaWebsite";
import CustomizedMessage from "./ja/customizedMessage";
import TheaterDailyShow from "./ja/theaterDailyShow";
import MemberShip from "./ja/membership";
import MailMagazine from "./ja/mailMagazine";
import MemberFilter from './ja/memberFilter';
import Dashboard from "./ja/dashboard";

export default {
  ...global,
  ...sideMenu,
  ...calendar,
  ...errorMsg,
  ...form,
  ...reigon,

  ...login,

  ...movie,
  ...restrict,
  ...schedule,
  ...ruleTemplate,
  ...discountRuleTemplate,
  ...version,

  ...shop,

  ...couponLib,

  ...report,

  ...house,

  ...setting,
  ...theatre,
  ...role,
  ...brand,
  ...accounting,
  ...otherGoods,
  ...clientManagement,
  ...userManagement,
  ...accountPayableManagement,
  ...accountPayable,
  ...accountReceivable,
  ...otherRevenue,
  ...nonArrivalTicketRecord,
  ...monthlyClosing,
  ...cashierReport,
  ...pdf,
  ...inventoryAdjustmentLog,

  ...dailyClosing,
  ...businessDaily,

  ...bookkeeping,
  ...operations,
  ...salesGroup,

  ...accountingReportDownload,

  ...pdfAccountsReceivableBalance,
  ...pdfFilmFeeBalance,
  ...pdfReceivableVerifyPdf,
  ...weather,
  ...businessDailyDetail,

  ...notification,
  ...Signage,
  ...CinemaWebsite,
  ...CustomizedMessage,
  ...TheaterDailyShow,
  ...MemberShip,
  ...MailMagazine,
  ...MemberFilter,
  ...Dashboard,
};
